module.exports = __webpack_public_path__ + "static/media/elephant.8adec592.m4a";